import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getPlanDetails } from "../../Subscription/service";
import Translate from "../../../Components/MultiLanguage/Translate";

const PlanDetails = ({ planKey, onBack ,flag ,planSelected}) => {


  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };
  const template = projectInfo?.projectConfig?.config?.TEMPLATE;
  const [image, setImage] = useState(false);

  const plan = planSelected;


  useEffect(() => {
    if (plan?.logo) {
      const img = new Image();
      img.onload = () => setImage(true);
      img.onerror = () => setImage(false);
      img.src = plan.logo;
    }
  }, [plan?.logo]);

  if (!plan) {
    return <div><Translate textKey={'loading'}/></div>;
  }

    return (
        <div className="plan-details-container">
          {image &&
            <div className="plan-banner">
                <img src={plan?.logo} alt={plan?.subscription_name} />
            </div>
           }
            <div className="plan-content">
                <h1 className="plan-title">{plan?.subscription_name}</h1>
                <p className="plan-description">{plan?.description}</p>
                <div className="plan-price">
                    {plan?.subscription_text}
                </div>
                {/* <a className={`back-button ${template === 'TEMPLATE_9' ? 'template-9' : ''}`} onClick={() => onBack(onBack)}>
                    <Translate textKey={'subscription_title'} />
                </a> */}
            </div>
        </div>
    );
};

export default PlanDetails;